export const _initialState = {
  allPromoProducts: {}
};
